import React from "react";
import { Box } from "grid-styled";
import { Field, FormSection } from "redux-form";
import { P, Price } from "../Text";
import { InputContainer, Select, Checkbox } from "../forms";

const NewSaleOptionsFormSection = () => {
  return (
    <FormSection name="options">
      <div>
        <Box pb={2}>
          <Field
            name="drawingDepth"
            labelText="Drawing Depth"
            component={InputContainer}
            fieldComponent={Select}
            options={[
              { depth: "2D", description: "2D" },
              { depth: "3D", description: "3D" }
            ]}
            valueKey="depth"
            labelKey="description"
          />
        </Box>
        <Box pb={2}>
          <Field name="pdfDrawings" component={Checkbox}>
            PDF Drawings
          </Field>
        </Box>
      </div>
    </FormSection>
  );
};

export default NewSaleOptionsFormSection;



// WEBPACK FOOTER //
// ./src/components/services/SalesDrawingOptionsFormSection.js